<template>
  <b-form-group :label="labelText">
    <validation-provider
      #default="{ errors }"
      :name="labelText"
      rules="required"
    >
      <b-form-input
        :value="value"
        dir="ltr"
        class="text-left"
        autocomplete="one-time-code"
        autocapitalize="characters"
        autocorrect="off"
        spellcheck="false"
        :placeholder="$t('auth.mfa-code-placeholder')"
        :state="errors.length > 0 ? false : null"
        :disabled="disabled"
        @input="$emit('input', $event)"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { BFormGroup, BFormInput } from 'bootstrap-vue'
import { ValidationProvider } from 'vee-validate'
import { required } from '@validations'

export default {
  name: 'MfaCodeField',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    labelText() {
      return this.label || this.$t('auth.mfa-code-label')
    },
  },
}
</script>
